export enum FeedbackReasonLabels {
  Other = 'Report a bug/request a feature',
  IncorectStructure = 'Incorrect "Reporting to"',
  WrongEM = 'Incorrect Engineering Manager',
  IncorectProject = 'Incorrect projects',
  ContactPRTeam = 'HR Team support needed',
}
